var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsxRuntime classic */
/** @jsx jsx */
import { keyframes } from '@emotion/react';
import { jsx } from 'theme-ui';
import { Box } from '../../';
/**
 * Following Carbon Components for the animation.
 * @see https://github.com/carbon-design-system/carbon-components-react/blob/master/src/components/SkeletonText/SkeletonText.js
 */
export const skeleton = keyframes `
0%  { width: 0%; left: 0; right: auto; opacity: 0.3; }
20% { width: 100%; left: 0; right: auto; opacity: 1; }
28% { width: 100%; left: auto; right: 0; }
51% { width: 0%; left: auto; right: 0; }
58% { width: 0%; left: auto; right: 0; }
82% { width: 100%; left: auto; right: 0; }
83% { width: 100%; left: 0; right: auto; }
96% { width: 0%; left: 0; right: auto; }
100% { width: 0%; left: 0; right: auto; opacity: 0.3; }
`;
/**
 * @param {object} props
 * @param {number} [props.offset] The offset for a staggered animation.
 * @param {string | number | string[]} [props.width]
 * @param {string | number | string[]} [props.height]
 * @param {import('theme-ui').ThemeUIStyleObject} [props.sx] SX props to apply to the text.
 * @param {React.ElementType} [props.as]
 
 */
export default function SkeletonBox(_a) {
    var { offset = 0, width, height, sx = {} } = _a, rest = __rest(_a, ["offset", "width", "height", "sx"]);
    return (jsx(Box, Object.assign({ sx: Object.assign({ variant: 'text.default', backgroundColor: 'skeleton', position: 'relative', width,
            height, '::before': {
                content: '""',
                position: 'absolute',
                height: '100%',
                width: '0%',
                top: 0,
                left: 0,
                backgroundColor: 'skeletonDark',
                borderRadius: 'inherit',
                animation: `3000ms ${500 + offset * 100}ms ease-in-out ${skeleton} infinite`,
            } }, sx) }, rest), "\u00A0"));
}
//# sourceMappingURL=SkeletonBox.js.map